import { render } from "./FeaturesPanel.vue?vue&type=template&id=a4dfdd5c&ts=true"
import script from "./FeaturesPanel.vue?vue&type=script&lang=ts"
export * from "./FeaturesPanel.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__